// @flow
import React, { Component } from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import firebase from "firebase"
import './App.css'
import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

import BoardView from "./components/BoardView"
import GameControls from "./components/GameControls"
import TopMenu from "./components/TopMenu"
import TopLeftMenu from "./components/TopLeftMenu"
import Fps from "./components/Fps"
import TimeElapsed from "./components/TimeElapsed"
import MapLibrary from "./components/MapLibrary"
import EditUnitForm from "./components/EditUnitForm"
import CloneMapForm from "./components/CloneMapForm"

import Unit, { createUnit } from "./lib/Unit"
import Game from "./lib/Game"
import { createConfig } from "./maps"
import { unitTypes, teams } from "./lib/gameInfo"
import { findAi, ais } from "./ais"


@observer
class App extends Component {

    initialMapId: number
    defaultsForNewBots: Object
    firebaseConnection: Object
    database: Object 
    mapsRef: Object
    @observable zoomFactor: number
    @observable showMapLibrary: boolean
    @observable.ref currentMap: Object
    @observable showCloneMapForm: boolean
    @observable.ref game: Game
    @observable.ref maps: Array<Object>

    constructor(props: Object) {
        super(props);
        this.maps = []
        this.setupFirebase()
        this.loadMaps()
        this.defaultsForNewBots = {}
        this.showCloneMapForm = false
        this.showMapLibrary = false
        this.zoomFactor = 1
        if (window.location.hash) {
            this.initialMapId = window.location.hash.replace("#", "")
        }
    }

    // Setup connection to FirebaseDB to load the Maps
    setupFirebase() {
        var config = {
            apiKey: "AIzaSyCjOgQ6KyPQBE2P1WRoWmRxrU4yW3r_8_o",
            authDomain: "railsproject-167109.firebaseapp.com",
            databaseURL: "https://railsproject-167109.firebaseio.com",
            projectId: "railsproject-167109",
            storageBucket: "railsproject-167109.appspot.com",
            messagingSenderId: "111385380920"
        };
        this.firebaseConnection = firebase.initializeApp(config);
        this.database = firebase.database()
        this.mapsRef = this.database.ref("maps")
    }

    // Load all the maps from Firebase
    loadMaps() {
        this.mapsRef.on("value", snapshot => {
            this.maps = Object.entries(snapshot.val()).map(([key, val]) => {
                val.id = key
                return val
            })
            if (!this.currentMap) {
                this.currentMap = this.initialMapId ? this.maps.filter(m => m.id == this.initialMapId)[0] : this.maps[0]
                this.createNewGame()
                this.updateWindowDimensions()
            }
        })
    }

    resetBoardView = () => {
        this.zoomFactor = 1
        this.refs.boardView.panX = 0
        this.refs.boardView.panY = 0
    }

    makeFullScreen = () => {
        var div = document.getElementById('root')
        if (div && div.requestFullscreen) {
            div.requestFullscreen();
        } else if (div && div.webkitRequestFullscreen) {
            div.webkitRequestFullScreen();
        }
    }

    selectMap = (map: Object) => {
        window.location.hash = "#" + map.id
        this.showMapLibrary = false
        this.currentMap = map
        this.createNewGame()
    }

    @action
    createNewGame = () => {
        this.game = new Game(createConfig(this.currentMap), 0)
        this.updateWindowDimensions()
    }

    reset = ({ jumpToTickNumber = -1 }: { jumpToTickNumber: number} = {}) => {
        this.game.resetBoard()
        this.game.jumpForwardToTick(jumpToTickNumber)
    }

    zoom = (deltaY: number) => {
        this.zoomFactor = Math.min(Math.max(this.zoomFactor + (deltaY > 0 ? -0.2 : 0.2), 0.4), 3)
    }

    // User has clicked an empty space on the board
    boardClick = (x: number, y: number) => {
        this.game.board.clearDistanceRings()
        if(this.zoomFactor !== 1) {
            // reset to normal zoom first. TOdo fix
            this.zoomFactor = 1 
            NotificationManager.success('Units can only be added at normal zoom level', null, 3000);
            return
        }
        // TODO: Cleanup. Hides then shows the form due to react state issue in the form.
        setTimeout(() => {
            let unit = createUnit({
                ai: findAi(ais.justAttack), 
                // Round to nearest coordinate divisible by 5
                x: Math.round(x/5) * 5,  
                y: Math.round(y/5) * 5, 
                team: teams.red, 
                type: unitTypes.assault,
                ...this.defaultsForNewBots
            })
            this.game.board.addUnit(unit)
            this.game.board.clickOnUnit(unit)
        }, 50)
    }

    clickOnUnit = (unit: Unit, clickCoordinates) => {
        this.clickCoordinates = clickCoordinates
        if (unit !== this.game.board.selectedUnit) {
            this.game.board.clearDistanceRings()
        }
        // TODO: Cleanup. Hides then shows the form due to react state issue in the form.
        setTimeout(() => {
            this.game.board.clickOnUnit(unit)
        }, 50)
    }

    saveBotDefaults = (defaults: Object): void => {
        this.defaultsForNewBots = defaults
    }

    startCloning = () => {
        this.game.pause()
        this.showCloneMapForm = true
    }

    cancelCloning = () => {
        this.showCloneMapForm = false
    }

    cloneMap = (name: string, atCurrentTime: boolean = false) => {
        this.cancelCloning()
        var newMapRef = this.mapsRef.push();
        let newMap = { 
            ...this.game.generateMapConfig({ name, atCurrentTime: atCurrentTime }),
            id: newMapRef.getKey() 
        }
        newMapRef.set(newMap)
        this.currentMap = newMap
        NotificationManager.success('Clone was Successfull', null, 1000);
    }
    cloneMapAtCurrentTime = (name: String) => { this.cloneMap(name, true) }

    saveMap = () => {
        this.database.ref("maps/" + this.currentMap.id).set({
            ...this.game.generateMapConfig({ atCurrentTime: false }),
            name: this.currentMap.name,
        })
        this.cancelCloning()
        NotificationManager.success('Map Was Saved', null, 1000);
    }

    lockCurrentMap = () => {
        if (!this.currentMap.locked && window.confirm("Are you sure you want to lock this map from further editing?")) {
            this.currentMap.locked = true
            this.database.ref("maps/" + this.currentMap.id).set(this.currentMap)
            NotificationManager.success('Map Was Locked', null, 1000);
        }
    }

    render() {
        // Show nothing if maps are not loaded
        if (!this.game) return <NotificationContainer/>;

        const { board } = this.game
        return (
            <div className="App">
                <NotificationContainer/>
                <MapLibrary 
                    visible={this.showMapLibrary}
                    hideMapLibrary={() => this.showMapLibrary = false}
                    currentMap={this.currentMap}
                    selectMap={this.selectMap}
                    maps={this.maps} />
                <CloneMapForm
                    cloneMap={this.cloneMap}
                    cloneMapAtCurrentTime={this.cloneMapAtCurrentTime}
                    show={this.showCloneMapForm}
                    cancelCloning={this.cancelCloning}
                    map={this.currentMap}
                    seconds={this.game.timeElapsedInSeconds} />
                <EditUnitForm
                    saveBotDefaults={this.saveBotDefaults}
                    board={board}
                    unit={board.selectedUnit}
                    unselectUnit={board.clearDistanceRings}
                    deleteUnit={board.deleteUnit} />
                <Fps game={this.game} />
                <BoardView
                    ref="boardView"
                    zoomFactor={this.zoomFactor}
                    changeZoom={this.zoom}
                    board={board}
                    clickOnUnit={this.clickOnUnit}
                    boardClick={this.boardClick} />
                <TimeElapsed
                    milliseconds={this.game.timeElapsedInMilliseconds}
                    seconds={this.game.timeElapsedInSeconds} />
                <GameControls
                    game={this.game}
                    reset={this.reset} />
                <TopMenu
                    lockCurrentMap={this.lockCurrentMap}
                    canSave={!this.currentMap.locked}
                    saveMap={this.saveMap}
                    resetBoardView={this.resetBoardView}
                    changeZoom={this.zoom}
                    startCloning={this.startCloning} />
                <TopLeftMenu
                    currentMap={this.currentMap}
                    openMapLibrary={() => this.showMapLibrary = true }
                    createNewMap={() => this.selectMap(this.maps[0])}
                    />

            </div>
        );
    }

    // Resize the board when the screen is resized (mobile changed from portrait to landscape)
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', () => this.updateWindowDimensions());
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.updateWindowDimensions());
    }

    updateWindowDimensions() {
        if (this.game) {
            this.game.board.screenWidth = window.innerWidth
            this.game.board.screenHeight = window.innerHeight
            console.log("updated")
        }
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js